import React from 'react';

// Evita la pantalla en blanco: si un componente truena al renderizar,
// muestra qué pasó y permite volver a intentar.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Error de interfaz:', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;

    return (
      <div style={{ maxWidth: 640, margin: '80px auto', padding: 24, fontFamily: 'sans-serif' }}>
        <h3 style={{ color: '#f5365c' }}>Algo salió mal al mostrar esta pantalla</h3>
        <p>
          La información que guardaste no se perdió; el problema fue solo al mostrar la página.
          Recarga para continuar. Si vuelve a pasar, comparte este detalle con soporte:
        </p>
        <pre style={{ background: '#f6f9fc', padding: 12, borderRadius: 6, whiteSpace: 'pre-wrap', fontSize: 13 }}>
          {String(error?.message || error)}
        </pre>
        <button
          type="button"
          className="btn btn-primary"
          onClick={() => window.location.reload()}
        >
          Recargar página
        </button>
      </div>
    );
  }
}

export default ErrorBoundary;
